 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"CategoryMenuComponent~CodeView~InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogC~eb09af7f":"CategoryMenuComponent~CodeView~InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogC~eb09af7f","CodeView~LocaleSwitcher~SearchBarComponent":"CodeView~LocaleSwitcher~SearchBarComponent","CodeView~NavigationHeaderView":"CodeView~NavigationHeaderView","CodeView":"CodeView","LocaleSwitcher~NavigationHeaderView":"LocaleSwitcher~NavigationHeaderView","NavigationHeaderView":"NavigationHeaderView","EntryView":"EntryView","LibraryView":"LibraryView","ReaderView":"ReaderView","RootView":"RootView","LocaleSwitcher":"LocaleSwitcher","SearchBarComponent":"SearchBarComponent","ResponsiveButtonComponent":"ResponsiveButtonComponent","CategoryMenuComponent~InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogComponent~~5397aa84":"CategoryMenuComponent~InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogComponent~~5397aa84","CategoryMenuComponent":"CategoryMenuComponent","InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogComponent~LocationDialogComponen~e6de7c41":"InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogComponent~LocationDialogComponen~e6de7c41","LanguageDialogComponent~LocationDialogComponent":"LanguageDialogComponent~LocationDialogComponent","LanguageDialogComponent":"LanguageDialogComponent","LibraryComponent":"LibraryComponent","LocationStatusComponent":"LocationStatusComponent","ReaderComponent":"ReaderComponent","InactivityDialogComponent":"InactivityDialogComponent","InvalidTokenDialogComponent":"InvalidTokenDialogComponent","LocationDialogComponent":"LocationDialogComponent","TermsAndConditionsDialogComponent":"TermsAndConditionsDialogComponent","AccessibilityButtonComponent":"AccessibilityButtonComponent","MagazineCellComponent":"MagazineCellComponent","PageComponent":"PageComponent","ThumbnailComponent":"ThumbnailComponent","ZoomButtonComponent":"ZoomButtonComponent","ThumbnailPageComponent":"ThumbnailPageComponent"}[chunkId]||chunkId) + "." + {"CategoryMenuComponent~CodeView~InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogC~eb09af7f":"cc35d754","CodeView~LocaleSwitcher~SearchBarComponent":"abd57c75","CodeView~NavigationHeaderView":"1f218fbe","CodeView":"a0052a36","LocaleSwitcher~NavigationHeaderView":"6438d80a","NavigationHeaderView":"2153c8e7","EntryView":"f93320b9","LibraryView":"a39bed44","ReaderView":"855cc7f5","RootView":"254b5760","LocaleSwitcher":"7c6a403f","SearchBarComponent":"157978c6","ResponsiveButtonComponent":"fc0452a7","CategoryMenuComponent~InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogComponent~~5397aa84":"e7a9d81e","CategoryMenuComponent":"2b17ec91","InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogComponent~LocationDialogComponen~e6de7c41":"19b739f8","LanguageDialogComponent~LocationDialogComponent":"8cb45c31","LanguageDialogComponent":"a2836ea4","LibraryComponent":"77f32c89","LocationStatusComponent":"d65a942e","ReaderComponent":"4f8ff383","InactivityDialogComponent":"fe5b454e","InvalidTokenDialogComponent":"9e4ebd19","LocationDialogComponent":"e9f004bc","TermsAndConditionsDialogComponent":"2cfdf241","AccessibilityButtonComponent":"cb19c710","MagazineCellComponent":"7912a048","PageComponent":"65aa8a50","ThumbnailComponent":"e4af88fa","ZoomButtonComponent":"bc940efe","ThumbnailPageComponent":"12d803bf"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"CategoryMenuComponent~CodeView~InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogC~eb09af7f":1,"CodeView~LocaleSwitcher~SearchBarComponent":1,"CodeView~NavigationHeaderView":1,"CodeView":1,"LocaleSwitcher~NavigationHeaderView":1,"NavigationHeaderView":1,"LocaleSwitcher":1,"SearchBarComponent":1,"CategoryMenuComponent~InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogComponent~~5397aa84":1,"CategoryMenuComponent":1,"InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogComponent~LocationDialogComponen~e6de7c41":1,"LanguageDialogComponent~LocationDialogComponent":1,"LanguageDialogComponent":1,"LibraryComponent":1,"LocationStatusComponent":1,"ReaderComponent":1,"InactivityDialogComponent":1,"InvalidTokenDialogComponent":1,"LocationDialogComponent":1,"TermsAndConditionsDialogComponent":1,"AccessibilityButtonComponent":1,"MagazineCellComponent":1,"PageComponent":1,"ThumbnailComponent":1,"ZoomButtonComponent":1,"ThumbnailPageComponent":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"CategoryMenuComponent~CodeView~InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogC~eb09af7f":"CategoryMenuComponent~CodeView~InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogC~eb09af7f","CodeView~LocaleSwitcher~SearchBarComponent":"CodeView~LocaleSwitcher~SearchBarComponent","CodeView~NavigationHeaderView":"CodeView~NavigationHeaderView","CodeView":"CodeView","LocaleSwitcher~NavigationHeaderView":"LocaleSwitcher~NavigationHeaderView","NavigationHeaderView":"NavigationHeaderView","EntryView":"EntryView","LibraryView":"LibraryView","ReaderView":"ReaderView","RootView":"RootView","LocaleSwitcher":"LocaleSwitcher","SearchBarComponent":"SearchBarComponent","ResponsiveButtonComponent":"ResponsiveButtonComponent","CategoryMenuComponent~InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogComponent~~5397aa84":"CategoryMenuComponent~InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogComponent~~5397aa84","CategoryMenuComponent":"CategoryMenuComponent","InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogComponent~LocationDialogComponen~e6de7c41":"InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogComponent~LocationDialogComponen~e6de7c41","LanguageDialogComponent~LocationDialogComponent":"LanguageDialogComponent~LocationDialogComponent","LanguageDialogComponent":"LanguageDialogComponent","LibraryComponent":"LibraryComponent","LocationStatusComponent":"LocationStatusComponent","ReaderComponent":"ReaderComponent","InactivityDialogComponent":"InactivityDialogComponent","InvalidTokenDialogComponent":"InvalidTokenDialogComponent","LocationDialogComponent":"LocationDialogComponent","TermsAndConditionsDialogComponent":"TermsAndConditionsDialogComponent","AccessibilityButtonComponent":"AccessibilityButtonComponent","MagazineCellComponent":"MagazineCellComponent","PageComponent":"PageComponent","ThumbnailComponent":"ThumbnailComponent","ZoomButtonComponent":"ZoomButtonComponent","ThumbnailPageComponent":"ThumbnailPageComponent"}[chunkId]||chunkId) + "." + {"CategoryMenuComponent~CodeView~InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogC~eb09af7f":"e11f6f67","CodeView~LocaleSwitcher~SearchBarComponent":"6f55bcba","CodeView~NavigationHeaderView":"b334234b","CodeView":"c354ad00","LocaleSwitcher~NavigationHeaderView":"165710b4","NavigationHeaderView":"78c9ebf6","EntryView":"31d6cfe0","LibraryView":"31d6cfe0","ReaderView":"31d6cfe0","RootView":"31d6cfe0","LocaleSwitcher":"720ada5c","SearchBarComponent":"2b767331","ResponsiveButtonComponent":"31d6cfe0","CategoryMenuComponent~InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogComponent~~5397aa84":"2a012898","CategoryMenuComponent":"a550dd0c","InactivityDialogComponent~InvalidTokenDialogComponent~LanguageDialogComponent~LocationDialogComponen~e6de7c41":"430694a0","LanguageDialogComponent~LocationDialogComponent":"d3831cd4","LanguageDialogComponent":"895cd67d","LibraryComponent":"0c7236d1","LocationStatusComponent":"58ab31cf","ReaderComponent":"d5dbb8ad","InactivityDialogComponent":"c7315fda","InvalidTokenDialogComponent":"c7315fda","LocationDialogComponent":"64ec2ed5","TermsAndConditionsDialogComponent":"c7315fda","AccessibilityButtonComponent":"ed9899ba","MagazineCellComponent":"99259fc5","PageComponent":"6537381b","ThumbnailComponent":"aeceff90","ZoomButtonComponent":"25260da5","ThumbnailPageComponent":"b29ff990"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
